import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "placeholder"]

  show(event) {
    const submitter = event.detail.formSubmission.submitter
    if (submitter?.hasAttribute("data-submit-placeholder-skip")) return
    // Enter submits through the form's first button even while it is hidden, which is not the one the candidate sees.
    if (submitter && submitter.getClientRects().length === 0) return

    this.#toggle(true)
  }

  restore(event) {
    if (!event.detail.success) this.#toggle(false)
  }

  #toggle(submitting) {
    this.formTarget.classList.toggle("tw-hidden", submitting)
    this.placeholderTarget.classList.toggle("tw-hidden", !submitting)
  }
}
